import React, { useEffect, useRef, useState } from "react";
import { departmentLabel } from "../lib/departmentLabel";

/**
 * 自由填写部门时，仅在未编辑状态展示工程部的新名称；聚焦后编辑原值，避免把显示名称拼进历史数据。
 * 接收及提交的 value 始终是原值，未修改历史单据时不会把显示名称写回数据库。
 */
export default function DepartmentInput({ value, onChange, departmentIdentity, component: InputComponent = "input", ...props }) {
  const [draft, setDraft] = useState(null);
  const lastInput = useRef(value);
  // 下拉或其他表单字段可在输入时替换部门；聚焦编辑期间同步新原值，避免后续按键基于展示名称写入。
  // 逐字输入记录本输入框刚提交的原值，区分外部替换与用户自己的编辑。
  const externalChange = draft !== null && value !== lastInput.current;
  useEffect(() => { if (externalChange) { lastInput.current = value; setDraft(value ?? ""); } }, [externalChange, value]);
  return <InputComponent {...props} value={draft === null ? departmentLabel(value, departmentIdentity) : externalChange ? (value ?? "") : draft}
    onFocus={() => { lastInput.current = value; setDraft(value ?? ""); }}
    onChange={(event) => { lastInput.current = event.target.value; setDraft(event.target.value); onChange(event); }}
    onBlur={() => setDraft(null)} />;
}
